// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiAnnual {
    'cap'?: string | null;
    'capMetAmount'?: string | null;
    'capExists'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiAnnual>> = [
        {
            "name":     "cap",
            "baseName": "cap",
            "type":     "string"
        },
        {
            "name":     "capMetAmount",
            "baseName": "capMetAmount",
            "type":     "string"
        },
        {
            "name":     "capExists",
            "baseName": "capExists",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiAnnual.attributeTypeMap;
    }
}
